module.exports = __webpack_public_path__ + "static/media/NDIC WET Cover.701c4b85.png";